const KEY = "dss_recent";
const uid = () => { try { return JSON.parse(localStorage.getItem("ez_uid") || "null"); } catch { return null; } };
const key = () => `${KEY}_${uid()}`;

export const setRecentUser = (id) => { if (id) localStorage.setItem("ez_uid", JSON.stringify(id)); else localStorage.removeItem("ez_uid"); localStorage.removeItem(KEY); };

export const getRecent = () => {
  if (!uid()) return [];
  try { return JSON.parse(localStorage.getItem(key()) || "[]"); } catch { return []; }
};

export const addRecent = (id) => { if (uid()) localStorage.setItem(key(), JSON.stringify([id, ...getRecent().filter((x) => x !== id)].slice(0, 12))); };

export const clearRecent = () => localStorage.removeItem(key());
